import { useId } from 'react';

import type { IconComponentBaseProps } from 'components/atoms/Icon/types';

import { useTheme } from 'styled-components';

type LogoutProps = IconComponentBaseProps;

export const Logout = ({ width = 16, height = 17, fill, className }: LogoutProps) => {
  const theme = useTheme();
  const maskId = useId();
  const iconFill = fill || theme.mantineColors.gray[7];

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <mask id={maskId} style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="17">
        <rect y="0.5" width="16" height="16" fill={iconFill} />
      </mask>
      <g mask={`url(#${maskId})`}>
        <path
          d="M3.53866 14.1667C3.20189 14.1667 2.91683 14.05 2.6835 13.8167C2.45016 13.5834 2.3335 13.2983 2.3335 12.9615V4.03854C2.3335 3.70176 2.45016 3.41671 2.6835 3.18337C2.91683 2.95004 3.20189 2.83337 3.53866 2.83337H7.50666C7.64844 2.83337 7.76722 2.88126 7.863 2.97704C7.95866 3.07271 8.0065 3.19149 8.0065 3.33337C8.0065 3.47526 7.95866 3.59404 7.863 3.68971C7.76722 3.78549 7.64844 3.83337 7.50666 3.83337H3.53866C3.48733 3.83337 3.44033 3.85476 3.39766 3.89754C3.35489 3.94021 3.3335 3.98721 3.3335 4.03854V12.9615C3.3335 13.0129 3.35489 13.0599 3.39766 13.1025C3.44033 13.1453 3.48733 13.1667 3.53866 13.1667H7.50666C7.64844 13.1667 7.76722 13.2146 7.863 13.3104C7.95866 13.406 8.0065 13.5248 8.0065 13.6667C8.0065 13.8086 7.95866 13.9274 7.863 14.023C7.76722 14.1188 7.64844 14.1667 7.50666 14.1667H3.53866ZM11.745 9.00004H6.56433C6.42244 9.00004 6.30361 8.95215 6.20783 8.85637C6.11216 8.76071 6.06433 8.64193 6.06433 8.50004C6.06433 8.35815 6.11216 8.23937 6.20783 8.14371C6.30361 8.04793 6.42244 8.00004 6.56433 8.00004H11.745L10.463 6.71804C10.3707 6.62571 10.3234 6.5131 10.3213 6.38021C10.3192 6.24732 10.3664 6.12915 10.463 6.02571C10.5596 5.92226 10.6767 5.86882 10.8143 5.86537C10.9519 5.86204 11.0724 5.91204 11.1758 6.01537L13.2387 8.07821C13.3591 8.19876 13.4193 8.33937 13.4193 8.50004C13.4193 8.66071 13.3591 8.80132 13.2387 8.92187L11.1758 10.9847C11.0767 11.0838 10.959 11.1327 10.8227 11.1314C10.6863 11.1302 10.5664 11.0778 10.463 10.9744C10.3664 10.8709 10.3199 10.7522 10.3233 10.618C10.3267 10.4838 10.3767 10.3684 10.4733 10.2719L11.745 9.00004Z"
          fill={iconFill}
        />
      </g>
    </svg>
  );
};
